export default __webpack_public_path__ + "static/media/horizon_film_image.a42b444c.png";